export default {};



// WEBPACK FOOTER //
// ./src/store/modules/file/state.js